import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ATPDashboardViews from "../../../views/retailerPerformance/atpDashboard";

const ATPDashboard = ({
  moduleName,
  sectionName,
  urlOuter,
  urlInner,
  headerSelectedDateFrom,
  headerSelectedDateTo,
  triggerAtpFseAPI,
  triggerATPOuterAPI,
  triggerATPInnerAPI,
  timestampArr,
  searchFields,
}) => {
  const dispatch = useDispatch();
  const distId = useSelector(
    (state) => state.homeReducer.getAllAPI.data.extraData.orgId
  );
  // const distId = "0660129707";
  // console.log("timestamp: ", timestampArr)
  // console.log("DIST ID======= ", distId);
  const [selectedFSE, setSelectedFSE] = useState(null);
  const [selectedFSEId, setSelectedFSEId] = useState(null);
  const [fseData, setFseData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [showInner, setShowInner] = useState(false);

  const [dropDownOptions, setDropDownOptions] = useState({
    name: "FSE",
    data: [],
    value: [],
  });

  const headers = {
    distId: searchFields?.partner?.partnerId
      ? searchFields?.partner?.partnerId
      : searchFields?.partner
      ? searchFields?.partner?.split("-")?.pop()?.trim()
      : distId,
    isRedisActive: "YES",
  };

  const [headersDash, setHeadersDash] = useState({
    distributorId: searchFields?.partner?.partnerId
      ? searchFields?.partner?.partnerId
      : searchFields?.partner
      ? searchFields?.partner?.split("-")?.pop()?.trim()
      : distId,
    isRedisActive: "YES",
    fseId: "All",
  });

  const setFSEFilterData = (res) => {
    // console.log("in callback")

    if (res.content.length === 0) {
      setIsDataLoading(false);
      setDropDownOptions({
        ...dropDownOptions,
        data: ["All", "Others"],
        value: ["All", "OTHERS"],
      });
      setFseData([
        { fseName: "All", fseId: "All" },
        { fseName: "Others", fseId: "OTHERS" },
      ]);
      setSelectedFSE("All");
      setSelectedFSEId("All");
      setHeadersDash({ ...headersDash, fseId: "All" });
      setIsDataLoading(false);
    } else {
      let newDropDownData = [],
        allFse = [];
      res.content.map((el) => {
        newDropDownData.push(el.fseName);
        allFse.push(el);
      });

      setDropDownOptions({
        ...dropDownOptions,
        data: ["All", ...newDropDownData, "Others"],
      });
      setFseData([
        { fseName: "All", fseId: "All" },
        ...allFse,
        { fseName: "Others", fseId: "OTHERS" },
      ]);
      setSelectedFSE(newDropDownData[0]);
      setSelectedFSEId(
        allFse.filter((item) => item.fseName === newDropDownData[0])[0].fseId
      );
      setHeadersDash({
        ...headersDash,
        fseId: allFse.filter((item) => item.fseName === newDropDownData[0])[0]
          .fseId,
      });
      setIsDataLoading(false);
    }
  };

  const changeHandler = (value) => {
    setSelectedFSE(value);
    setShowInner(false);
    setSelectedFSEId(fseData.filter((item) => item.fseName === value)[0].fseId);
    setHeadersDash({
      ...headersDash,
      fseId: fseData.filter((item) => item.fseName === value)[0].fseId,
    });
  };

  useEffect(() => {
    function getFSEfilters() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: "/atp-fse-filter",
        },
        params: headers,
        callback: setFSEFilterData,
      };
      return dispatch(triggerAtpFseAPI(obj));
    }

    getFSEfilters();
  }, []);

  //for getting atp data
  function getATPDash() {
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: urlOuter,
      },
      params: headersDash,
    };
    // setShowInner(false);
    return dispatch(triggerATPOuterAPI(obj));
  }

  //for getting atp inner data
  const getATPInner = (lowerBound, upperBound) => {
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: urlInner,
      },
      params: {
        ...headersDash,
        lowerBound: lowerBound,
        upperBound: upperBound,
      },
    };
    setShowInner(true);
    return dispatch(triggerATPInnerAPI(obj));
  };

  return (
    <ATPDashboardViews
      isDataLoading={isDataLoading}
      timestampArr={timestampArr}
      dropDownOptions={dropDownOptions}
      changeHandler={changeHandler}
      selectedFSE={selectedFSE}
      selectedFSEId={selectedFSEId}
      getATPDash={getATPDash}
      getATPInner={getATPInner}
      showInner={showInner}
      setShowInner={setShowInner}
    />
  );
};

export default ATPDashboard;
